import api from "app/api";
import {ActivationType, getTokenData} from "../../../activation/activationApi";

export interface AcceptInvitationForm {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}

export async function acceptInvitation(item: AcceptInvitationForm, token: string) {
  return api.post(
    `/identity/accept-invitation?token=${token}`,
    {
      AcceptInvitationForm: item,
    },
    {
      public: true,
    }
  );
}

export async function getInvitationDetails(token: string) {
  return getTokenData(token, ActivationType.INVITATION);
}